const CACHE_NAME = 'sgv-endesa-files-v1';
const KEY_PREFIX = 'https://sgv-endesa-cache.local/file/';

async function openCache() {
  return caches.open(CACHE_NAME);
}

export async function getCachedBlob(id) {
  try {
    const cache = await openCache();
    const resp = await cache.match(KEY_PREFIX + id);
    if (!resp) return null;
    return await resp.blob();
  } catch {
    return null;
  }
}

async function storeBlobInCache(id, blob) {
  try {
    const cache = await openCache();
    await cache.put(KEY_PREFIX + id, new Response(blob, { headers: { 'Content-Type': blob.type || 'application/octet-stream' } }));
    return true;
  } catch {
    return false;
  }
}

export async function preCacheEndesa(docs, getSignedUrl, getFileBlob) {
  if (!('caches' in window) || !navigator.onLine) return 0;
  let count = 0;
  for (const doc of docs) {
    try {
      const existing = await getCachedBlob(doc.id);
      if (existing) { count++; continue; }
      let blob;
      if (doc.cloudinary_url) {
        const { url } = await getSignedUrl(doc.id);
        if (!url) continue;
        const resp = await fetch(url);
        if (!resp.ok) continue;
        blob = await resp.blob();
      } else {
        blob = await getFileBlob(doc.id);
        if (!blob) continue;
      }
      await storeBlobInCache(doc.id, blob);
      count++;
    } catch {
      // Skip failed docs silently
    }
  }
  return count;
}
